import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Cartao } from '../../componentes/base';

/** O caminho da página na casca (`paginasCasca` do Pipeline). Fica aqui para o Configurações não importar a tela do Pipeline. */
export const CAMINHO_CONFIGURACOES_CRM = '/crm/configuracoes';

/**
 * Rodada crm1 (SPEC-M2): Admin > Configurações > CRM. A ficha do CRM no novo desenho pede as Configurações do CRM "dentro de
 * Admin/Configurações"; a página continua no CRM (`/crm/configuracoes`), e esta aba leva até ela. Só aparece com o Pipeline
 * instalado e `pipeline.editar` (a mesma permissão da página).
 */
export function AtalhoCrm() {
  const { t } = useTranslation('configuracoes');
  return (
    <Cartao titulo={t('crm.titulo')}>
      <div className="flex flex-col gap-3 text-sm" data-atalho-config-crm="">
        <p className="text-tinta-2">{t('crm.intro')}</p>
        <Link to={CAMINHO_CONFIGURACOES_CRM} className="flex w-fit items-center gap-2 rounded-lg border border-borda px-4 py-3 font-medium text-acento-forte hover:bg-sup-2">
          {t('crm.abrir')}
          <ArrowRight className="size-4" aria-hidden />
        </Link>
      </div>
    </Cartao>
  );
}
